<template>
  <div class='h100vh-100'>
    <ToolBarForGnbPmDataQueryRightList ref="toolBarForGnbPmDataQueryRightList" :enableStatus='enableStatus'  ></ToolBarForGnbPmDataQueryRightList>
    <ContentForGnbPmDataQueryRightList ref="contentForGnbPmDataQueryRightList" @gnbPmDataQueryListPageClick="gnbPmDataQueryListPageClick" :dataLength="dataLength"></ContentForGnbPmDataQueryRightList>
    <CustomDialog ref='gnbPmDataSearchDialog' :element='gnbPmDataSearchDialog.element' :styles='gnbPmDataSearchDialog.style'>
      <template v-slot:dialog-content>
        <GnbPmDataSearchDialog ref='gnbPmDataSearch'></GnbPmDataSearchDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='upload' :element='upload.element' :styles='upload.styles1'>
      <template v-slot:dialog-content>
        <AddDialog ref='addObj'></AddDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='recoverDialog' :element='upload.element' :styles='upload.styles1'>
      <template v-slot:dialog-content>
        <RecoverDialog ref='recoverObj' :selectedId=selectedRowId></recoverDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='batchRecoverDialog' :element='batchDialog.element' :styles='batchDialog.style'>
      <template v-slot:dialog-content>
        <BatchRecoverDialog ref='batchRecoverObj' ></BatchRecoverDialog>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
  import ToolBarForGnbPmDataQueryRightList from "./ToolBarForGnbPmDataQueryRightList";
  import ContentForGnbPmDataQueryRightList from "./ContentForGnbPmDataQueryRightList";
  import {EventBus} from "../../../../plugins/eventBus";
  import CustomDialog from "../../../common/CustomDialog";
  import GnbPmDataSearchDialog from "./dialog/GnbPmDataSearchDialog";
  import DateUtil from "../util/DateUtil";
  import AddDialog from './dialog/addDialog';
  import RecoverDialog from './dialog/recoverDialog';
  import BatchRecoverDialog from './dialog/BatchRecoverDialog';
  export default {
    name: 'GnbPmDataQueryRightList',
    props: [
      'treeClickInfo'
    ],
    components: {
      ToolBarForGnbPmDataQueryRightList,
      ContentForGnbPmDataQueryRightList,
      CustomDialog,
      GnbPmDataSearchDialog,
      AddDialog,
      RecoverDialog,
      BatchRecoverDialog
    },
    data() {
      return {
        selectRowId: '',
        uploadProps: {status:0},
        enableStatus: 0,
        upload: {
          styles: {
            width: '810px',
            height: '752px',
            model: true,
            visible: false
          },
          styles1: {
            width: '500px',
            height: '300px',
            model: true,
            visible: false
          },
          element: {
            refName: "detailLog",
            isClose: true,
            buttonGroup: [
              { click: this.recoverCommit, buttonModel: { content: this.$t('Common.confirm') } },
            ],
            title: this.$t('MML.importCfg')
          },
        },
        gnbPmDataSearchDialog: {
          style: {
            width: '800px',
            height: '600px',
            visible: false,
            model: true
          },
          element: {
            title: this.$t('MML.recoverOrBackup'),
            target: this.$refs.contentForGnbPmDataQueryRightList,
            refName: 'gnbPmDataSearchElement',
            buttonGroup: [
              { click: this.closeGnbPmDataSearchDialog, buttonModel: { content: this.$t('Common.cancel') } },
              { click: this.gnbPmDataSearchCommit, buttonModel: { content: this.$t('Pm.finish'), isPrimary: true } }
            ],
            isClose: true
          }
        },
        batchDialog: {
          style: {
            width: '600px',
            height: '500px',
            visible: false,
            model: true
          },
          element: {
            title: this.$t('MML.batchBackup'),
            target: this.$refs.pmTaskManagementListForGnb,
            refName: 'addGnbTaskElement',
            buttonGroup: [
              { click: this.recoverCommit, buttonModel: { content: this.$t('Common.cancel') } },
              { click: this.recoverCommit, buttonModel: { content: this.$t('Pm.finish'), isPrimary: true } }
            ],
            isClose: true
          }
        },
        dataLength: 0,
        startTime: '',
        endTime: '',
        checkNodeIdList: [],
        neId: '',
        spaceCode: '',
        paramTypeCode: ''
      };
    },
    methods: {

      gnbPmDataQueryListPageClick(currentPage){
        this.$axios.post('/lte/ems/pm/gnb/query/getGnbPmData.html', {
          startTime: this.startTime,
          endTime: this.endTime,
          checkNodeIdList: this.checkNodeIdList,
          neId: this.neId,
          spaceCode: this.spaceCode,
          paramTypeCode: this.paramTypeCode,
          page: {
            pageNo: currentPage,
            pageSize: 18
          }
        }).then((response) => {
          const result = response.data.resultVal.result;
          if (result.length != 0) {
            this.$refs.contentForGnbPmDataQueryRightList.page.totalRecordsCount = response.data.resultVal.totalCount;
            this.$refs.contentForGnbPmDataQueryRightList.page.currentPage = response.data.resultVal.pageNo;
          } else {
            this.$refs.contentForGnbPmDataQueryRightList.page.totalRecordsCount = 0;
            this.$refs.contentForGnbPmDataQueryRightList.page.currentPage = 1;
          }
          this.$refs.contentForGnbPmDataQueryRightList.dataSourceOfGnbPmDataQuery = result;
          this.$loading.hideLoadding();
        });
        this.$refs.gnbPmDataSearchDialog.close();
      },

      closeGnbPmDataSearchDialog(){
        this.$refs.gnbPmDataSearchDialog.close();
      },
      recoverCommit(){
        this.$refs.upload.close();
        this.$refs.recoverDialog.close();
        this.$refs.batchRecoverDialog.close();
        this.$loading.showLoadding(this.$t('System.loading'));
        let startTimeParam = new Date(`${DateUtil.getTodayYearMonthDay()} 00:00:00`);
        let endTimeParam = new Date(`${DateUtil.getTodayYearMonthDay()} 23:59:59`);
        //this.$refs.contentForGnbPmDataQueryRightList.getColumnsOfGnbPmDataQuery(this.$refs.gnbPmDataSearch.checkNodeList);
        //this.dataLength = this.$refs.gnbPmDataSearch.checkNodeList.length;
        this.$refs.contentForGnbPmDataQueryRightList.$refs.gnbPmDataQueryList.refreshColumns();
        this.queryTableData(DateUtil.getTr069DateString(startTimeParam),DateUtil.getTr069DateString(endTimeParam));
        this.$loading.hideLoadding();
      },

      gnbPmDataSearchCommit(){

        const ruleDatas = this.$refs.gnbPmDataSearch.validateOfGnbPmSearchDialog();
        if (!ruleDatas) {
          return;
        }
        this.startTime = DateUtil.getTr069DateString(this.$refs.gnbPmDataSearch.startTime);
        this.endTime = DateUtil.getTr069DateString(this.$refs.gnbPmDataSearch.endTime);

        let paramList = this.treeClickInfo.id.split('_');
        this.spaceCode  = paramList[0];
        this.paramTypeCode = paramList[1];
        this.neId = paramList[0];

        console.log('paramList', paramList);
        console.log('paramTypeCode', this.paramTypeCode);
        console.log('spaceCode', this.spaceCode);
        console.log('neId', this.neId);

        this.$refs.contentForGnbPmDataQueryRightList.getColumnsOfGnbPmDataQuery(this.$refs.gnbPmDataSearch.checkNodeList);
        this.dataLength = this.$refs.gnbPmDataSearch.checkNodeList.length;
        this.$refs.contentForGnbPmDataQueryRightList.$refs.gnbPmDataQueryList.refreshColumns();
        this.$refs.gnbPmDataSearchDialog.close();
        this.$loading.showLoadding(this.$t('System.loading'));
        this.queryTableData(this.startTime,this.endTime);
        this.$loading.hideLoadding();

      },
      queryTableData(startTimeParam,endTimeParam){
        this.$axios.post('/lte/ems/config/mml//getGnbPmData.html', {
          startTime: startTimeParam,
          endTime: endTimeParam,
          checkNodeIdList: this.checkNodeIdList,
          neId: this.neId,
          spaceCode: this.spaceCode,
          paramTypeCode: this.paramTypeCode,
          page: {
            pageNo: 1,
            pageSize: 18
          }
        }).then((response) => {
          const result = response.data.resultVal.result;
          if (result.length != 0) {
            this.$refs.contentForGnbPmDataQueryRightList.page.totalRecordsCount = response.data.resultVal.totalCount;
            this.$refs.contentForGnbPmDataQueryRightList.page.currentPage = 1;
          } else {
            this.$refs.contentForGnbPmDataQueryRightList.page.totalRecordsCount = 0;
            this.$refs.contentForGnbPmDataQueryRightList.page.currentPage = 1;
          }
          this.$refs.contentForGnbPmDataQueryRightList.dataSourceOfGnbPmDataQuery = [];
          this.$refs.contentForGnbPmDataQueryRightList.dataSourceOfGnbPmDataQuery = result;
          console.log(this.$t('MML.recover'))
          console.log(this.$t('System.fileNotNull'))
          console.log(this.$refs.contentForGnbPmDataQueryRightList.dataSourceOfGnbPmDataQuery)
      });
      },
      eventEmit(type, content) {
        EventBus.$emit('toast', {type: type, content: content})
      },
      methodList(operator) {

        switch (operator) {
          case 'query':
            if(!this.treeClickInfo.id){
                this.eventEmit('warning', this.$t('MML.selBaseAlert'));
                return;
            }
            this.enableStatus = '1';
            this.queryData();
            break;
          case 'addDialog':
            this.addDialog();
            break;
          case 'recoverDialog':
            let selectRecords = this.$refs.contentForGnbPmDataQueryRightList.getCheckedData(false);
            if(selectRecords){
              if(selectRecords[0].TYPE !== 1){
                 this.eventEmit('warning', this.$t('selTypeAlert'));
                 return;
              }
              this.recoverDialog(selectRecords[0]);
            }

            break;
          case 'bachRecover':
            this.batchRecoverDialog();
            break;
          default:
        }
      },
      batchRecoverDialog(){
         this.$refs.batchRecoverDialog.show();
         this.$refs.batchRecoverObj.$refs.pmGnbTopoTreeRef.getPmGnbTopoTree();
      },
      recoverDialog(row){
        const checkedDataList = this.$refs.contentForGnbPmDataQueryRightList.getCheckedData(false);
        if (checkedDataList) {
          const checkedData = checkedDataList[0];
          this.selectedRowId = checkedData.id;
          this.$refs.recoverDialog.show();
          this.$refs.recoverObj.recoverBySelected(row);
        }
      },
      addDialog() {
        this.uploadProps = {status: 1};
        this.$refs.upload.show();
      },
      queryData(){

        this.$refs.gnbPmDataSearch.bindValidateOfGnbPmSearchDialog();
        this.$refs.gnbPmDataSearchDialog.show();
      }
    },
    watch: {
    }
  };
</script>

<style>
</style>
